<template>
  <section>
    <b-button
      size="lg"
      variant="outline-default"
      @click="$bvModal.show(`book-languages-${uuid}`)"
    >{{ $t('book-language-selector-button.label') }}</b-button>
    <b-modal
      centered
      size="lg"
      :id="`book-languages-${uuid}`"
      :title="$t('book-language-selector-button.modal.book-language-selector.title')"
    >
      <b-list-group>
        <b-list-group-item
          href="#"
          v-for="language in languages"
          :key="language.english_name"
          @click="select(language.english_name)"
        >{{ $i18n.locale === 'tw' ? language.chinese_name : language.english_name }}</b-list-group-item>
      </b-list-group>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import Vue from 'vue'
import UUID from '@estudioliver/vue-uuid-v4'
import { ButtonPlugin, ListGroupPlugin, ModalPlugin } from 'bootstrap-vue'

Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)
Vue.use(ListGroupPlugin)
Vue.use(UUID)

export default {
  name: 'book-language-selector-button',
  props: {
    languages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      uuid: null
    }
  },
  methods: {
    select(language_english_name) {
      this.$emit('select', language_english_name);
      this.$bvModal.hide(`book-languages-${this.uuid}`);
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    this.uuid = this.$uuidKey()
  }
}
</script>
